import { Button, Checkbox, Modal } from 'antd'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const SealCopyAssistant = ({
  columns = [],
  copySourceFieldNameBuilder,
  fieldNameBuilder,
  rowGroups = [],
}) => {
  const { t } = useTranslation()
  const { getValues, setValue } = useFormContext()

  const [modalOpen, setModalOpen] = useState(false)
  // selected: Set of "groupKey|columnKey"
  const [selected, setSelected] = useState(new Set())

  const closeModal = () => {
    setModalOpen(false)
    setSelected(new Set())
  }

  const toggleCheck = (groupKey, columnKey) => {
    const key = `${groupKey}|${columnKey}`
    setSelected(prev => {
      const next = new Set(prev)
      next.has(key) ? next.delete(key) : next.add(key)

      return next
    })
  }

  const handleCopy = () => {
    selected.forEach(selKey => {
      const [groupKey, columnKey] = selKey.split('|')
      const group = rowGroups.find(g => g.key === groupKey)
      const column = columns.find(c => c.key === columnKey)
      if (!group || !column) return

      group.rows.forEach(row => {
        const srcName = copySourceFieldNameBuilder({ column, group, row })
        const dstName = fieldNameBuilder({ column, group, row })
        setValue(dstName, getValues(srcName), {
          shouldDirty: true,
          shouldValidate: true,
        })
      })
    })
    closeModal()
  }

  return (
    <>
      <div className="seals__copy-btn-row">
        <Button onClick={() => setModalOpen(true)} type="primary">
          {t('rob.survey.seals.copyAssistant.button')}
        </Button>
      </div>

      <Modal
        onCancel={closeModal}
        open={modalOpen}
        title={t('rob.survey.seals.copyAssistant.title')}
        width={480}
        footer={[
          <Button key="cancel" onClick={closeModal}>
            {t('rob.survey.seals.copyAssistant.cancel')}
          </Button>,
          <Button
            disabled={selected.size === 0}
            key="copy"
            onClick={handleCopy}
            type="primary"
          >
            {t('rob.survey.seals.copyAssistant.copy')}
          </Button>,
        ]}
      >
        <p className="seals__modal-desc">
          {t('rob.survey.seals.copyAssistant.description')}
        </p>

        <table className="seals__modal-grid">
          <thead>
            <tr>
              <th />
              {columns.map(col => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rowGroups.map(group => (
              <tr key={group.key}>
                <td className="seals__modal-row-label">{group.label}</td>
                {columns.map(col => (
                  <td className="seals__modal-cell" key={col.key}>
                    <Checkbox
                      checked={selected.has(`${group.key}|${col.key}`)}
                      onChange={() => toggleCheck(group.key, col.key)}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Modal>
    </>
  )
}

SealCopyAssistant.propTypes = {
  columns: PropTypes.array,
  copySourceFieldNameBuilder: PropTypes.func.isRequired,
  fieldNameBuilder: PropTypes.func.isRequired,
  rowGroups: PropTypes.array,
}

export default SealCopyAssistant
